import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 p-4 bg-orange-50 border border-orange-200 rounded-lg"
}
const _hoisted_2 = { class: "mb-4 text-sm" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "p-2 bg-gray-50 rounded" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "p-2 bg-gray-50 rounded" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "flex justify-end gap-2" }
const _hoisted_10 = ["disabled"]

import { computed } from 'vue';
import { useTaskHistory } from '@/composables/tasks/useTaskHistory';
import ModalBox from "@/components/v2/Modal/ModalBox.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'JustificationModal',
  setup(__props) {

const taskHistory = useTaskHistory();

const getValueDisplay = (value: unknown): string => {
  if (value === null || value === undefined) return 'None';

  if (typeof value === 'object' && value !== null) {
    if (value.value) {
      return value.value;
    }

    const obj = value as Record<string, unknown>;
    return (obj.label as string) || (obj.name as string) || (obj.title as string) || JSON.stringify(value);
  }

  return String(value);
};

const handleClose = () => {
  taskHistory.cancelJustification();
};

const isEndingBathProcessEarly = computed(() => {
  return taskHistory.justificationModal.fieldName.includes('Ending Bath Process Early');
});


return (_ctx: any,_cache: any) => {
  return (_unref(taskHistory).justificationModal.isOpen)
    ? (_openBlock(), _createBlock(ModalBox, {
        key: 0,
        onClose: handleClose
      }, {
        header: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Justification Required")
        ])),
        main: _withCtx(() => [
          (isEndingBathProcessEarly.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "flex items-start gap-3" }, [
                  _createElementVNode("svg", {
                    class: "w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5",
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                      "clip-rule": "evenodd"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "text-sm font-semibold text-orange-800 mb-1" }, "Ending Bath Process Early"),
                    _createElementVNode("p", { class: "text-sm text-orange-700" }, " You are about to end the bath process before the expected completion time. This action requires justification. Please provide a detailed reason for ending the process early. ")
                  ])
                ], -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_2, [
            (!isEndingBathProcessEarly.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[4] || (_cache[4] = _createTextVNode(" Please provide a reason for changing ")),
                  _createElementVNode("strong", null, _toDisplayString(_unref(taskHistory).justificationModal.fieldName), 1),
                  _cache[5] || (_cache[5] = _createTextVNode(". "))
                ], 64))
              : (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_unref(taskHistory).justificationModal.fieldName), 1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-sm text-gray-600 mb-1" }, "From:", -1)),
            _createElementVNode("div", _hoisted_5, _toDisplayString(getValueDisplay(_unref(taskHistory).justificationModal.oldValue)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-sm text-gray-600 mb-1" }, "To:", -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(getValueDisplay(_unref(taskHistory).justificationModal.newValue)), 1)
          ]),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(taskHistory).justificationModal.justification) = $event)),
            class: "w-full border rounded p-2 mb-4",
            rows: "3",
            placeholder: isEndingBathProcessEarly.value ? 'Please explain why you are ending the bath process early...' : 'Enter justification...'
          }, null, 8, _hoisted_8), [
            [_vModelText, _unref(taskHistory).justificationModal.justification]
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10",
              onClick: handleClose
            }, " Cancel "),
            _createElementVNode("button", {
              class: "text-white bg-primary hover:bg-primary-dark focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:z-10",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(taskHistory).submitJustification())),
              disabled: !_unref(taskHistory).justificationModal.justification.trim()
            }, " Confirm ", 8, _hoisted_10)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})